import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import HeadingSkeleton from '@atlaskit/skeleton';
import { AgentCardSkeleton } from '@atlassian/studio-browse-kit/agent-card-skeleton';
import { CardList } from '@atlassian/studio-browse-kit/ui/card-list';

export const CardListSkeleton = ({
	count,
	showHeading = false,
	testId,
}: {
	count: number;
	showHeading?: boolean;
	testId?: string;
}): React.JSX.Element => {
	const isUplift = fg('rovo_agents_studio_browse_kit_uplift');
	const skeletonKeys = Array.from({ length: count }, (_, index) => `skeleton-card-${index}`);

	return (
		<Stack space="space.200">
			{isUplift && <UFOLoadHold name="browse-agents-card-list-loading" />}
			{showHeading ? (
				<Inline alignBlock="center">
					<HeadingSkeleton width={isUplift ? 160 : 80} height={20} isShimmering={!isUplift} />
				</Inline>
			) : null}
			<CardList columns={isUplift ? 4 : 3} testId={testId}>
				{skeletonKeys.map((key, index) => (
					<AgentCardSkeleton key={key} testId={testId ? `${testId}--card-${index}` : undefined} />
				))}
			</CardList>
		</Stack>
	);
};
